export enum AttributeStatus {
    ACTIVE = "Active", INACTIVE = "Inactive"
}